import { ToastContainer } from "react-bootstrap";
import { useAppSelector } from "../../redux-stores/hooks/hooks";
import {
  getToasts,
  getToastsDisabled,
} from "../../redux-stores/reducers/ToastState";
import ToastWrapper from "./ToastWrapper";

function ToastHandler() {
  const toasts = useAppSelector(getToasts);
  const disabled = useAppSelector(getToastsDisabled);

  return (
    <ToastContainer>
      {!disabled
        ? toasts.map((t, i) => (
            <ToastWrapper
              key={`${Date.now()}${t.timestamp}`}
              bg="Danger"
              body={t.body}
              duration={t.duration}
              timestamp={t.timestamp}
              header={t.header}
            />
          ))
        : null}
    </ToastContainer>
  );
}

export default ToastHandler;
